<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-4">
      <historial :ordinario="true" />
      <nuevo :ordinario="true" v-if="permiteEnvio" />
      <b-alert class="mt-4" variant="warning" show v-else>
        Solicitudes en horario fuera de rango
      </b-alert>
    </div>
  </div>
</template>

<script>
import historial from "../../components/requisiciones/HistorialSolicitud.vue";
import nuevo from "../../components/requisiciones/NuevaSolicitud.vue";

export default {
  name: "BandejaOrdinario",
  components: {
    historial,
    nuevo,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    permiteEnvio: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    const inicio = new Date();
    const fin = new Date();
    const hoy = new Date();

    inicio.setDate(inicio.getDate() - inicio.getDay() + 1);
    inicio.setHours(0);
    inicio.setMinutes(0);
    inicio.setSeconds(0);

    fin.setDate(fin.getDate() - fin.getDay() + 6);
    fin.setHours(15);
    fin.setMinutes(0);
    fin.setSeconds(0);

    if (inicio.getTime() < hoy.getTime() && hoy.getTime() < fin.getTime()) {
      this.permiteEnvio = true;
    }
  },
};
</script>